import { render, staticRenderFns } from "./PowerImitateMain.vue?vue&type=template&id=1ccb4b95&scoped=true"
import script from "./PowerImitateMain.vue?vue&type=script&lang=js"
export * from "./PowerImitateMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb4b95",
  null
  
)

export default component.exports